import React, { useCallback, useEffect, useState, useContext, useRef } from "react";
import { get_zeus_resources_tags_path}  from "../../../atom/Apollo_links";
import { apollo_useStyles, options_reviewstatus, options_reviewreason, options_mimetype, options_mimetype_zeus }  from "../../../atom/Apollo_styles";
import { ApolloMessage } from "../../../atom/Apollo_Mesasge";
import { ApolloContext } from "../../../atom/Apollo_Context";
import { CrAssetsTagRow, LogRecordDialog } from "./AdvertisementModelZeus";
import { useParams } from "react-router-dom";
import {useDropzone} from "react-dropzone";
import {ApolloAxios, getResultType,} from "../../../atom/Apollo_ApiRequest3";
import axios from "axios";

import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';

import Card from "@material-ui/core/Card/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions/CardActions";
import Typography from '@material-ui/core/Typography';

import {ApolloDataTable, STORAGE_KEY} from "../../../atom/Apollo_DataTable";
import {MUIDataTableColumnDef, MUISortOptions, SelectableRows} from "mui-datatables";
import {ApolloTabPanel, ApolloTabs2} from "../../../atom/Apollo_Tabs"
import Grid from "@material-ui/core/Grid";
import makeAnimated from "react-select/animated";
import {ZEUS_DELIVERY_TYPE, ZEUS_PMP_TYPE, ZEUS_AD_TAG_TYPE} from "../../../atom/Apollo_styles";

function getModalStyle() {
    return {
        top: `50%`,
        left: `50%`,
        transform: `translate(-50%, -50%)`,
    };
}

const useStyles = makeStyles(theme => ({
    root: {
        Width: "100%",
        backgroundColor: theme.palette.background.paper,
        position: 'relative',
        overflow: 'auto',
        height: 550,
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        position: 'absolute',
        width: '60%',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
    tablescroll: {
       overflow: "scroll",
       maxHeight: 550,
    },
    cardaction: {
        marginLeft : "auto",
        marginRight : "10",
    },
    inline: {
        display: 'inline',
    },
}));

interface TabPanelProps {
    children?: React.ReactNode;
    index: any;
    value: any;
}

type PossibleSize = {
    width: number;
    height: number;
};

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}>
            {children}
        </div>
    );
}

// @ts-ignore
export const CreativeTagModal = ({ platformAccountId, tabinit, isSuccess, setTag, setSelectedTagAsset, isSelectedAdGroup, campaignType, pmpType, optionPlacementSettings}) => {
    const {state, dispatch} = React.useContext(ApolloContext);
    const dialogClasses = useStyles();
    const classes = apollo_useStyles();
    const [modalStyle] = useState(getModalStyle);
    const [open, setOpen] = useState(false);
    const [tabstate, setTabstate] = useState( tabinit );

    const [possibleSize, setPossibleSize] = useState<PossibleSize[]>([]);
    const [tagSizeStr, setTagSizeStr] = useState([""]);

    const {data, setmsg} = useContext(ApolloMessage);
    const [tags, setTags] = useState<CrAssetsTagRow[]>([]);

    const handleListItemClick = (
        id: number,
        tagName: string,
        tagSize: string,
        tagTypeLabel: string
    ) => {
        setSelectedTagAsset({
            id: id,
            name: tagName,
            size: tagSize,
            type: tagTypeLabel,
        });
        setTag([{
            adAccountTagResourceId: id,
        }])
    

        handleClose();
    };

    const handleOpen = async () => {
        const possibleSize:PossibleSize[] = []
    
        // プレースメント情報からサイズ抽出
        if (campaignType === ZEUS_DELIVERY_TYPE.DSP &&
            (pmpType === ZEUS_PMP_TYPE.PLACEMENT_DESIGNATION || pmpType === ZEUS_PMP_TYPE.PREMIUM_PLACEMENT_DESIGNATION)) {
    
            for (const setting of optionPlacementSettings) {
                setting.placementSettingTypeSizes.forEach((element: any) => {
                    possibleSize.push({
                        width: element.adSizeWidth,
                        height: element.adSizeHeight
                    });
                });
            }
        }
    
        setPossibleSize(possibleSize);
        setTagSizeStr(possibleSize.map(size => `${size.width}×${size.height}`));
    
        await fetchTags(possibleSize);
    
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    // タグサイズメッセージを改行された形に整形
    const sizeMessageIndention = () => {
        const texts = tagSizeStr.map((item, index) => {
            return (
                <React.Fragment key={index}>{item}<br/></React.Fragment>
            )    
        })
        return texts
    }

    const fetchTags = async (sizeList: PossibleSize[]) => {
        const url = `${process.env.REACT_APP_API_ENDPOINT}${get_zeus_resources_tags_path}?account_id=${platformAccountId}&per_page=9999&page=1&sort=created&direction=desc`;
      await ApolloAxios.get(url).then(response => {
        if (response.status !== 200) {
          return Promise.reject({
            open: true,
            type: getResultType(response.status === 400 ? -1 : -9),
            errmsg: "タグアセット情報を取得できませんでした",
          });
        }
        if (response?.data) {
            const filtered = response.data
                .filter((r1: any) =>
                    r1.reviewStatus !== 3 &&
                    sizeList.some(size => size.width === r1.width && size.height === r1.height)
                )
                .map((r1: any) => ({
                    ...r1,
                    tagSize: `${r1.width}×${r1.height}`,
                    tagTypeLabel: ZEUS_AD_TAG_TYPE.find(type => type.value === r1.tagType)?.label ?? "",
                }));
            setTags(filtered);
        }
      }).catch(err => {
        setTags([])
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: err.type,
            message: err.errmsg,
          }
        });
      })
    }

    const columns: MUIDataTableColumnDef[] = [
        {
            name: "id",
            label: "広告アセットID",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "tagName",
            label: "タグアセット名",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "tagSize",
            label: "サイズ",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "tagTypeLabel",
            label: "タグ種別",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "",
            label: "",
            options: {
                filter: false,
                sort: false,
                customBodyRenderLite: (idx: number) => {
                    const data = tags[idx];
                    return (
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => handleListItemClick(
                                data.id,
                                data.tagName,
                                data.tagSize,
                                data.tagTypeLabel,
                            )}
                        >
                            選択
                        </Button>
                    );
                },
            }
        },
    ]

    const sortOrder: MUISortOptions = {
        name: "id",
        direction: 'desc',
    }
    const selectableRows: SelectableRows = 'none';
    const options = {
        filter: true,
        download: false,
        print: false,
        sort: true,
        sortOrder: localStorage.getItem(STORAGE_KEY.APOLLO_CREATIVE_DIALOG) ? undefined : sortOrder,
        selectableRows: selectableRows,
        rowsPerPage: 10,
        rowsPerPageOptions: [10, 25, 50],
        jumpToPage: true,
        expandableRows: false,
        expandableRowsHeader: false,
        expandableRowsOnClick: false,
        storageKey: STORAGE_KEY.APOLLO_CREATIVE_DIALOG,
        textLabels:{
            body: {noMatch: "該当データが存在しません"}
        },
    }
    return (
        <div>
            <Button 
                variant="contained"
                color="primary"
                disabled={isSuccess || !isSelectedAdGroup ? true : false}
                onClick={handleOpen}>
                {'タグアセット選択'}
            </Button>

            <Modal
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={open}
                onClose={handleClose}>
                <div style={modalStyle} className={dialogClasses.paper}>
                    <>
                        <Card className={dialogClasses.root} elevation={0}>
                            <CardContent>
                            <Grid container spacing={3}>
                                <Grid item xs={2}>
                                    <Typography>設定可能なサイズ</Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography variant="body2" gutterBottom component="div" color="textSecondary">
                                                【サイズ】<br/>
                                                {sizeMessageIndention()}
                                    </Typography>
                                </Grid>
                            </Grid>
                            </CardContent>
                            <ApolloTabs2 value={tabstate} setValue={setTabstate} tablabel={["広告アセット選択"]} />
                            <ApolloTabPanel value={tabstate} index={0}>
                                <Grid item xs={12}>
                                    <ApolloDataTable
                                        title=""
                                        data={tags}
                                        columns={columns}
                                        options={options}
                                    />
                                </Grid>
                                <CardActions className={classes.cardActionButton}>
                                    <Button
                                        variant="contained"
                                        color="default"
                                        onClick={handleClose}
                                        className={classes.button}
                                    >
                                    閉じる
                                    </Button>
                                </CardActions>
                            </ApolloTabPanel>
                        </Card>
                    </>
                </div>
            </Modal>
        </div>
    );
};
